<template>
  <AsyncDpplTreeselect
    :key="field.id"
    v-model="treeselectModel"
    :async="field.async"
    :options="field.options"
    :async-url="field.asyncUrl"
    placeholder="Type to begin search"
    show-select-all
    :show-inline-apply="inlineApply"
    flat
    @apply-filters="$emit('apply-filters')"
    @add-snackbar="$emit('add-snackbar', $event)"
  />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

// Loads the treeselect only when needing to be rendered
const AsyncDpplTreeselect = defineAsyncComponent(() => import('@/components/filter/treeSelectNewDesign/DpplTreeSelectNew.vue'));

const props = defineProps({
  field: {
    type: Object,
    default: () => ({}),
  },
  inlineApply: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits(['set-temp-filters', 'set-to-applied-filters', 'apply-filters', 'add-snackbar']);

const treeselectModel = computed({
  get() {
    return props.field.value;
  },
  set(value) {
    emits('set-temp-filters', value);
  },
});
</script>

<style lang="less" scoped>
:deep(.v-field) {
  font-size: 13px;
  font-weight: 500;
}
</style>
